/* Built In Imports */
import { useRouter } from 'next/router';

/* External Imports */
import { Box, Flex, Image, Text } from '@chakra-ui/react';

/* Internal Imports */
/* Components */
import ShareIcon from '@components/Icon/ShareIcon';

/* Services */

/**
 * Renders TopPubBanner Component
 *
 * @param {object} sectionContent - Data from api
 * @param {string} region - Region of page
 * @param {string} lang - Language of page
 * @returns
 */

const TopPubBanner = ({ sectionContent }) => {
  const router = useRouter();
  const url = router.asPath;
  return (
    <Box h="auto">

      <Box maxWidth={1300} mx="auto" w="100%" pb={{ base: "40px", md: "50px" }} >
        <Box height={{ base: "100%", md: "481px" }} position="relative" >
          <Box clipPath="polygon(0 0, 100% 0, 100% 80%, 0 100%)" bg="#F3F3F3" pos="absolute" width="100%" height={{ base: "256px", md: "100%" }} display={{ base: "none", md: "block" }}>

          </Box>
          <Box
            w={{ base: '24px', md: '32px' }}
            h={{ base: '24px', md: '32px' }}
            pos="absolute"
            top={{ base: '15px', md: '18px' }}
            right={{ base: '14px', md: '73px' }}
            zIndex={5}
          >
            <ShareIcon url={url} background="transparent" />
          </Box>
          <Flex flexDir={{ base: "column", md: "row" }} position={{ base: "relative", md: "absolute" }} top="0" left={0} right={0} w="100%" bg={{ base: "#FFFCF5", md: "transparent" }}>
            <Box clipPath="polygon(0 0, 100% 0, 100% 80%, 0 100%)" bg="#F3F3F3" pos="absolute" width="100%" height={{ base: "256px", md: "100%" }} display={{ base: "block", md: "none" }} zIndex={"0"}>

            </Box>
            <Box w={{ base: "100%", md: "43%" }} maxW={{ base: "100%", md: "531px" }} height={{ base: "283px", md: "440px", lg: '570px' }} ml={{ base: "0", md: "32px", lg: "82px" }} textAlign="center" display={{ base: "flex" }} zIndex={"1"} pos="relative" pl={{ base: "15px" }} pt={{ base: "15px" }} mt={{ md: '7%', lg: '2%' }}>

              <Image alt={sectionContent?.heroImage?.alt}
                w={{ base: '263px', lg: '90%' }}
                h={{ base: '100%', lg: '90%' }}
                src={sectionContent?.heroImage?.url || "https://static.sadhguru.org/d/46272/1690191476-default-card-image.png"}
                loading="eager"
                fallback={<>Loading...</>}
                fallbackSrc="https://static.sadhguru.org/d/46272/1690191476-default-card-image.png" />
            </Box>
            <Flex w={{ base: "100%", md: "57%" }} h={{ base: "auto", md: "auto" }}
              pl={{ base: "20px" }} pt={{ base: "21px", sm: "60px", md: "100px", lg: "141px" }}
              pb={{ base: "27px" }}
              pr="5px"
              textAlign="left">
              <Text
                as="h1"
                // pt={['0px', '40px', '44px', '0']}
                fontFamily="'FedraSansStd-A-medium', serif"
                lineHeight={{ base: "34px", md: "58px" }}
                fontSize={[26, 32, 44, 44]}
                width={{ base: "100%", md: "420px", xl: "518px" }}
              >
                {sectionContent?.title}
              </Text>
            </Flex>
          </Flex>
        </Box>
      </Box>
    </Box>

  );
};

export default TopPubBanner;
